var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 57,
    viewBox: "0 0 40 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_1219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 57C15.52 57 20 52.744 20 47.5V38H10C4.48 38 0 42.256 0 47.5C0 52.744 4.48 57 10 57Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5C0 23.256 4.48 19 10 19H20V38H10C4.48 38 0 33.744 0 28.5Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5C0 4.256 4.48 0 10 0H20V19H10C4.48 19 0 14.744 0 9.5Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0H30C35.52 0 40 4.256 40 9.5C40 14.744 35.52 19 30 19H20V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 28.5C40 33.744 35.52 38 30 38C24.48 38 20 33.744 20 28.5C20 23.256 24.48 19 30 19C35.52 19 40 23.256 40 28.5Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_1219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 57,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFigma);
export default __webpack_public_path__ + "static/media/logos_figma.bcc82abc726a02df0d312d4034d18261.svg";
export { ForwardRef as ReactComponent };